/**
 * «Недавние» статьи (фаза 0.6) — в localStorage, без сервера: работает и у
 * сотрудников iiko (у них нет записи в users, серверные reads не пишутся).
 * Последние 10, самые свежие первыми. Все обращения в try/catch —
 * localStorage может быть недоступен (приватный режим, квота).
 */
export interface RecentArticle {
  slug: string;
  title: string;
  icon?: string | null;
  at: number;
}

const KEY = 'wiki-recent';
const LIMIT = 10;

export function readRecent(): RecentArticle[] {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? (JSON.parse(raw) as RecentArticle[]) : [];
    return Array.isArray(list) ? list.filter((r) => r && typeof r.slug === 'string') : [];
  } catch {
    return [];
  }
}

export function pushRecent(item: Omit<RecentArticle, 'at'>): void {
  try {
    const list = readRecent().filter((r) => r.slug !== item.slug);
    list.unshift({ ...item, at: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, LIMIT)));
  } catch {
    /* localStorage недоступен — просто не запоминаем */
  }
}
